import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { BookingCustomerInformationDtoGen } from "@/services/booking/v1/data-contracts";

@IsFilterable
class CustomerInformationBase implements BookingCustomerInformationDtoGen {
  @FilterConfig({
    displayName: "objects.customerInformation.email",
    type: FilterTypes.STRING
  })
  email: string;

  @FilterConfig({
    displayName: "objects.customerInformation.firstName",
    type: FilterTypes.STRING
  })
  firstName?: string;

  @FilterConfig({
    displayName: "objects.customerInformation.lastName",
    type: FilterTypes.STRING
  })
  lastName?: string;

  @FilterConfig({
    displayName: "objects.customerInformation.phone",
    type: FilterTypes.STRING
  })
  phone?: string;

  @FilterConfig({
    displayName: "objects.customerInformation.numberPlate",
    type: FilterTypes.STRING
  })
  numberPlate?: string;

  constructor(data?: BookingCustomerInformationDtoGen) {
    this.email = data?.email ?? "";
    this.firstName = data?.firstName;
    this.lastName = data?.lastName;
    this.phone = data?.phone;
    this.numberPlate = data?.numberPlate;
  }
}

type ICustomerInformation = CustomerInformationBase;
const CustomerInformation = Filter.createForClass(CustomerInformationBase);

export { ICustomerInformation, CustomerInformation };
